module.exports = __webpack_public_path__ + "static/img/solution_monitor.80e9bb39.png";